<template>
  <div
    class="book-page"
    :class="{ 'book-page--forced-landscape': shouldRotateReader }"
    :data-reader-rotation="shouldRotateReader ? '90' : undefined"
  >
    <BookHeader v-if="isFree" :is-p-c="isPC" @home="goHome" @create-same="goCreateSame" />

    <BookReader @create-same="goCreateSame" />
  </div>
</template>

<script setup lang="ts">
  import BookReader from './components/BookReader.vue';
  import BookHeader from './components/BookHeader.vue';
  import { useProjectStore } from '@/store/project.ts';
  import { useReaderLandscape } from '@/hooks/reader/useReaderLandscape';
  import { storeToRefs } from 'pinia';

  // 工作台完整地址（阅读端独立部署时用于跳回工作台）；需带协议，否则会被当作相对路径拼接。
  const workbenchUrl = `https://${import.meta.env.VITE_WEB_DOMAIN}`;

  const projectStore = useProjectStore();
  const { isFree } = storeToRefs(projectStore);
  console.log('isFree', isFree.value);
  const { isPC, shouldRotateReader } = useReaderLandscape();

  const goHome = () => {
    window.location.href = `${workbenchUrl}`;
  };

  const goCreateSame = () => {
    window.location.href = `${workbenchUrl}`;
  };
</script>

<style scoped>
  .book-page {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .book-page--forced-landscape {
    inset: auto;
    top: 50%;
    left: 50%;
    width: 100vh;
    width: 100dvh;
    height: 100vw;
    transform: translate(-50%, -50%) rotate(90deg);
    transform-origin: center;
  }

  /* 不支持 dvh 的浏览器:用 JS 写入的 --app-dvh 兜底(见 utils/viewportUnitFallback.ts)。
     强制横屏时宽度取「视口高度」,所以 width 用 --app-dvh。 */
  @supports not (width: 100dvh) {
    .book-page--forced-landscape {
      width: calc(var(--app-dvh, 1vh) * 100);
    }
  }
</style>
